export const complianceRoute = { label: 'Reviews', path: 'reviews' };
